import "./style.css";
import { initializeOffice, loadSetting, saveSetting } from "./office-adapter.js";

const BASE_SALES = 10;
const GROWTH_KEY = "growth";
const DEFAULT_GROWTH = 20;
const MIN_GROWTH = 0;
const MAX_GROWTH = 50;

const growthInput = document.getElementById("growth");
const growthValue = document.getElementById("growth-value");
const forecastEl = document.getElementById("forecast");
const statusEl = document.getElementById("status");

function clampGrowth(value) {
  const growth = Number(value);
  if (!Number.isFinite(growth)) {
    return DEFAULT_GROWTH;
  }
  return Math.min(MAX_GROWTH, Math.max(MIN_GROWTH, growth));
}

function forecastSales(growth) {
  return BASE_SALES * (1 + growth / 100);
}

function render(growth) {
  const value = clampGrowth(growth);
  growthInput.value = String(value);
  growthValue.textContent = String(value);
  forecastEl.textContent = `$${forecastSales(value).toFixed(1)}M`;
  return value;
}

async function persist(growth) {
  const saved = await saveSetting(GROWTH_KEY, growth);
  statusEl.textContent = saved ? "Saved to presentation" : "Browser preview";
}

growthInput.addEventListener("input", () => {
  render(growthInput.value);
});

growthInput.addEventListener("change", () => {
  const growth = render(growthInput.value);
  persist(growth);
});

async function start() {
  const info = await initializeOffice();
  const inOffice = Boolean(info && info.host);
  const savedGrowth = inOffice ? loadSetting(GROWTH_KEY) : null;
  render(savedGrowth === null ? DEFAULT_GROWTH : savedGrowth);
  statusEl.textContent = inOffice ? "Loaded from presentation" : "Browser preview";
}

start();
